import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Secure } from "lib/authorization/secure"
import { IfTooltip } from "lib/if-tooltip"
import { downloadRegisterExcel } from "routes/asset-register/lib/download-register-excel"
import { useIsAnythingBeingMapped } from "routes/asset-register/plugins/asset-mapping/use-is-anything-being-mapped"
import { useIsAnythingRefining } from "routes/asset-register/plugins/asset-mapping/use-is-anything-refining"

const isProcessingMsg =
    "Export is unavailable while Mobiliser is processing this register. It will re-enable when mapping completes."

export function ExportRegisterButton({ id }) {
    const { register } = useBoundContext()
    const isMapping = useIsAnythingBeingMapped()
    const isRefining = useIsAnythingRefining()
    const isProcessing = isMapping || isRefining

    return (
        <Secure hide demand="manageAssetRegister">
            <IfTooltip condition={isProcessing} title={isProcessingMsg}>
                <Button
                    size="small"
                    disabled={isProcessing}
                    startIcon={<Iconify icon="mdi:download" />}
                    onClick={downloadExcel}
                    data-cy="register-excel-download"
                    aria-label="Export Register Data button"
                    sx={{ mr: 2 }}
                >
                    Export Register Data
                </Button>
            </IfTooltip>
        </Secure>
    )

    async function downloadExcel() {
        await downloadRegisterExcel({
            registerId: id,
            registerName: register?.name,
        })
    }
}
